import { createI18n } from 'vue-i18n'

export type AppLocaleMessages = Record<string, Record<string, unknown>>
export type AppLocale = 'uz' | 'ru' | 'en'
export const APP_LOCALE_STORAGE_KEY = 'yuksalish.locale'
export const DEFAULT_APP_LOCALE: AppLocale = 'uz'

export function getStoredLocale(): AppLocale {
  try {
    const value = globalThis.localStorage?.getItem(APP_LOCALE_STORAGE_KEY)
    return value === 'ru' || value === 'en' || value === 'uz' ? value : DEFAULT_APP_LOCALE
  } catch {
    return DEFAULT_APP_LOCALE
  }
}

export function storeLocale(locale: AppLocale): void {
  try {
    globalThis.localStorage?.setItem(APP_LOCALE_STORAGE_KEY, locale)
  } catch {
    // The selected locale still applies for this session when storage is unavailable.
  }
}

const messages = {
  en: { common: { ready: 'Application foundation is ready', language: 'Interface language', signOut: 'Sign out', signIn: 'Sign in', signingIn: 'Signing in...', email: 'Email', password: 'Password', validating: 'Validating session...', accessDenied: 'Access denied', noAppPermission: 'Your account does not have the permissions required for this application.', noPagePermission: 'Your account does not have permission to open this page.', returnOverview: 'Return to overview', pageNotFound: 'Page not found', pageMissing: 'The requested page does not exist in this application.', primaryNavigation: 'Primary navigation', user: 'User' } },
  ru: { common: { ready: 'Основа приложения готова', language: 'Язык интерфейса', signOut: 'Выйти', signIn: 'Войти', signingIn: 'Вход...', email: 'Эл. почта', password: 'Пароль', validating: 'Проверка сессии...', accessDenied: 'Доступ запрещён', noAppPermission: 'У вашей учётной записи нет необходимых прав для этого приложения.', noPagePermission: 'У вашей учётной записи нет права открыть эту страницу.', returnOverview: 'Вернуться к обзору', pageNotFound: 'Страница не найдена', pageMissing: 'Запрошенная страница не существует в этом приложении.', primaryNavigation: 'Основная навигация', user: 'Пользователь' } },
  uz: { common: { ready: 'Ilova asosi tayyor', language: 'Interfeys tili', signOut: 'Chiqish', signIn: 'Kirish', signingIn: 'Kirilmoqda...', email: 'Elektron pochta', password: 'Parol', validating: 'Seans tekshirilmoqda...', accessDenied: 'Kirish taqiqlangan', noAppPermission: 'Hisobingizda ushbu ilova uchun zarur ruxsatlar mavjud emas.', noPagePermission: 'Hisobingizda ushbu sahifani ochish ruxsati mavjud emas.', returnOverview: 'Asosiy sahifaga qaytish', pageNotFound: 'Sahifa topilmadi', pageMissing: 'So‘ralgan sahifa ushbu ilovada mavjud emas.', primaryNavigation: 'Asosiy navigatsiya', user: 'Foydalanuvchi' } },
}

export function createAppI18n(
  appMessages: AppLocaleMessages = {},
) {
  return createI18n({
    legacy: false,
    locale: getStoredLocale(),
    fallbackLocale: DEFAULT_APP_LOCALE,
    messages: {
      uz: { ...messages.uz, ...(appMessages.uz ?? {}) },
      en: { ...messages.en, ...(appMessages.en ?? {}) },
      ru: { ...messages.ru, ...(appMessages.ru ?? {}) },
    },
  })
}
